import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {resetPresentationReducerAction} from '../../store/actions/presentation.actions';
import {logout} from '../../service/auth.service';
import {logoutUser} from '../../store/actions/auth.actions';
import ConfirmModal from '../../incase-domain/components/modals/confirmModal/ConfirmModal';

interface LogoutModalProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
}

function LogoutModal({isOpen, setOpen}: LogoutModalProps): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = (): void => {
        logout().finally(() => {
            dispatch(logoutUser());
            dispatch(resetPresentationReducerAction());
            navigate('/');
        });
    };

    return (
        <ConfirmModal
            message={t('header.logoutText')}
            icon="solar:logout-3-bold"
            isOpen={isOpen}
            onConfirm={() => handleLogout()}
            confirmText={t('header.logoutConfirm')}
            showCancel
            onCancel={() => setOpen(false)}
        />
    );
}

export default LogoutModal;
